module.exports = __webpack_public_path__ + "static/media/KOLconnection.2aa9872c.png";